import type { CustomButtonAttrs } from './customButton.types';
import { parseDataAttrs } from '@/shared/helpers/parseDataAttrs';

export const parseCustomButtonProps = (properties: Record<string, any>) =>
  parseDataAttrs<CustomButtonAttrs>(properties, {
    href: '',
    title: '',
    variant: 'white',
    icon: '',
    iconTheme: 'fad',
    iconPosition: 'prefix',
  });
